import sortBy from 'lodash/sortBy';

export const getSplittedArticlePrice = (price: number) => {
  const normalPriceFranken = Math.floor(price);
  const normalPriceRappen = Math.round((price - normalPriceFranken) * 100)
    .toString()
    .padStart(2, '0');

  return {
    normalPriceFranken,
    normalPriceRappen
  };
};

export function addSpaceAfterComma(value?: string) {
  return value ? value.replace(',', ', ') : value;
}

export function sortBghArticles<T extends { isAction: boolean; pricePerSellUnit: number; articleNumber: string }>(
  allRawArticles: T[]
) {
  return sortBy(allRawArticles, [
    article => !article.isAction,
    article => article.pricePerSellUnit,
    article => Number.parseInt(article.articleNumber)
  ]);
}

export function sortAghArticles<T extends { isAction: boolean; status: string; articleNumber: string }>(
  allRawArticles: T[]
) {
  const statusRank = (status: string) => {
    if (status === 'a') return 0;
    if (status === 'b') return 1;
    return 2;
  };

  return sortBy(allRawArticles, [
    article => statusRank(article.status),
    article => !article.isAction,
    article => article.articleNumber
  ]);
}

export const INACTIVE_ARTICLE_STATUSES = ['*', ' '];

export function isArticleNumber(value: string) {
  const regex = /^\d{6}$/;
  return regex.test(value);
}
